{
  "confirmationNumber": "Номер подтверждения {number}",
  "dateTimeRange": "{date} с {startTime} до {endTime}"
}
